import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { CommissionManagement } from '../modal';


export default function reducer(state: CommissionManagement = new CommissionManagement(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.TOP_CARDS_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.TOP_CARDS_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.TOP_CARDS_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
